import { useForm } from 'react-hook-form';
import { Input } from 'components/Form';
import { Button } from 'components/Button';
import styles from 'styles/Card.module.css';

export const RequestDemoContent = () => {
    const {
        register,
        handleSubmit,
        watch,
        formState: { errors },
    } = useForm();
    const onSubmit = (data) => {
        console.log(data);
    };

    return (
        <>
            <header>
                <h1>Request Demo</h1>
            </header>
            <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
                <p>
                    Thank you for your interest in Everest. Please enter your
                    contact info so we can reach you.
                </p>
                <Input
                    type='text'
                    label='fname'
                    placeholder='First Name'
                    register={register}
                    required
                    errors={errors}
                    watch={watch}
                />
                <Input
                    type='text'
                    label='lname'
                    placeholder='Last Name'
                    register={register}
                    required
                    errors={errors}
                    watch={watch}
                />
                <Input
                    type='text'
                    label='company'
                    placeholder='Company Name'
                    register={register}
                    required
                    errors={errors}
                    watch={watch}
                />
                <Input
                    type='email'
                    label='email'
                    placeholder='Email'
                    register={register}
                    required
                    errors={errors}
                    watch={watch}
                />
                <Input
                    type='text'
                    label='phoneNumber'
                    placeholder='Phone Number'
                    register={register}
                    required
                    errors={errors}
                    watch={watch}
                />
                <Button
                    uitype='cta'
                    color='primary-dark'
                    size='lg'
                    fullwidth
                    isLoading={null}
                >
                    Submit Contact Info
                </Button>
            </form>
        </>
    );
};
